import { useState } from "react";

const useMultiStepWizard = ({numberOfSteps, initialMode, initialActiveStepIndex}: useMultiWizardProps) => {
  const viewModeIndex = -1;
  const [currentStepIndex, setCurrentStepIndex] = useState(initialActiveStepIndex ? initialActiveStepIndex : 0);
  const [previousStepIndex, setPreviousStepIndex] = useState(viewModeIndex);
  const [mode, setMode] = useState<modeType>(initialMode);

  const next = () => {
    setMode("create");

    if(previousStepIndex !== viewModeIndex){
      setCurrentStepIndex(previousStepIndex);
      setPreviousStepIndex(viewModeIndex);
    }
    else{
      setCurrentStepIndex(i => {
        if (i >= numberOfSteps -1) {
          setMode("edit");
          return -1;
        };
        
        return i + 1;
      })
    }
  }

  const back = () => {
    setCurrentStepIndex(i => {
      if (i == 0) return i;
      return i - 1;
    })
  }

  const goTo = (index: number) => {
    setPreviousStepIndex(currentStepIndex);
    setCurrentStepIndex(index);
    setMode("edit");
  }

  const isActive = (index: number): boolean => {
    return currentStepIndex == index;
  }

  const haveBack = (): boolean => {
    return currentStepIndex > 0;
  }

  const isLastStep = (): boolean => {
    return currentStepIndex == numberOfSteps - 1;
  }

  const deactivateAllSteps = () => {
    setCurrentStepIndex(viewModeIndex);
    setMode("edit");
  }
  
  return {
    currentStepIndex,
    goTo,
    next,
    back,
    isActive,
    haveBack,
    isLastStep,
    mode,
    deactivateAllSteps,
  }
}

export default useMultiStepWizard;

type useMultiWizardProps = {
  initialActiveStepIndex?: number;
  numberOfSteps: number;
  initialMode: modeType;
}

type modeType = "create" | "edit";